
import VAlert from './views/message/index'; //弹窗

export default {
  install(Vue) {
    Vue.component('VAlert', VAlert);
  }
}



// WEBPACK FOOTER //
// ./src/vue-component.js